const config = window.appicationConfig

export default config
